import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=22a56480&scoped=true"
import script from "./Merchant.vue?vue&type=script&lang=js"
export * from "./Merchant.vue?vue&type=script&lang=js"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=22a56480&prod&scoped=true&lang=css"
import style1 from "./Merchant.vue?vue&type=style&index=1&id=22a56480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a56480",
  null
  
)

export default component.exports